import { useEffect, useRef, useState } from 'react';

import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../UI/Button';
import Loading from '../../UI/Loading';
import Checkbox from '../../UI/Checkbox';

import bemClassName from '../../utils/bem';

import photo_default from '../../assets/images/passport-default.png';

import './index.scss';
import PrivateData from '../../API/PrivateData';
import Icon from '../../UI/Icon';
import { RootState } from '../../store';
import { setVerified } from '../../store/reducers/profile/autorizationStatutsSlice';
import Modal from '../../UI/Modal';

const proofIdentity = bemClassName('proof-identity');

const ProofIdentity = () => {
  // const [error, setError] = useState(null);
  const [isEnabled, setEnabled] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [facing, setFacing] = useState('user');
  const [photoPassport, setPhotoPassport] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [checkbox, setCheckBox] = useState<boolean>();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [passportError, setPassportError] = useState<string>();

  const [isPassport, setIsPassport] = useState<boolean>(true);

  const [isPreApprove, setIsPreApprove] = useState<boolean>(false);

  const [isApproved, setIsApproved] = useState<boolean>(false);

  const videoRef = useRef<any | null>();
  const streamRef = useRef<any | null>();

  const isPaswordVerified = useSelector(
    (state: RootState) => state.autorizationStatus.isPaswordVerified,
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleSetCheckBox = () => {
    if (!checkbox) {
      setCheckBox(true);
    } else {
      setCheckBox(false);
    }
  };

  const uploadPhoto = () => {
    const handleChange = (event: any) => {
      setEnabled(true);
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          if (reader.result) {
            setPhotoPassport(new File([file], file.name));
          }
        };
      }
    };

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = handleChange;
    input.click();
  };

  const startStream = (ref: any) => {
    navigator.mediaDevices
      .getUserMedia({
        audio: false,
        video: {
          facingMode: facing,
        },
      })
      .then((stream) => {
        streamRef.current = stream;
        if (ref) {
          // eslint-disable-next-line no-param-reassign
          ref.current.srcObject = streamRef.current;
          // eslint-disable-next-line no-param-reassign
          ref.current.onloadedmetadata = () => ref.current.play();
        }
      })
      .catch((err) => {
        // setError(err.name);
        console.log(err);
      });
  };

  const stopStream = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track: any) => track.stop());
    }
  };

  const makePhoto = (videoRefPassport: any) => {
    const canvas = document.createElement('canvas');
    const video = videoRefPassport.current;
    if (video) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext('2d');
      if (context) {
        if (facing === 'user') {
          context.scale(-1, 1);
          context.drawImage(video, 0, 0, -canvas.width, canvas.height);
        } else {
          context.drawImage(video, 0, 0, canvas.width, canvas.height);
        }
        if (videoRefPassport === videoRef) {
          canvas.toBlob((blob) => {
            if (blob) {
              const file = new File([blob], 'passport.png', {
                type: 'image/png',
              });
              setPhotoPassport(file);
            }
          }, 'image/png');
        }
      }
    }
  };

  const deletePhoto = (ref: any) => {
    if (ref) {
      if (ref === videoRef) {
        setEnabled(true);
        setPhotoPassport(null);
        startStream(ref);
      }
    }
  };

  const handleSavePassportDataPhoto = async () => {
    if (photoPassport) {
      const result = await PrivateData.getPrivateAddedPassportPhoto(photoPassport);
      if (result.error) {
        setPassportError(result.error);
      } else {
        if (result.passport) {
          setIsPreApprove(true);
        }
        if (result.passport?.error) {
          setPassportError(result.passport.error);
        }
      }
    }
  };

  useEffect(() => {
    PrivateData.getPrivateUser().then((item) => {
      const passportData = item?.passport;
      if (!passportData || passportData?.validate?.novalid) {
        setIsPassport(false);
      }
      if (passportData?.approved) {
        setIsApproved(true);
      }
      if (passportData?.error) {
        setPassportError(passportData.error);
      }
    });
  }, [isPassport]);

  useEffect(() => {
    if (photoPassport !== null && checkbox) {
      setDisabledButton(true);
    } else {
      setDisabledButton(false);
    }
  }, [photoPassport, checkbox]);

  useEffect(() => {
    // setError(null);
    stopStream();
    if (isEnabled) {
      startStream(videoRef);
    }
  }, [isEnabled, facing]);

  useEffect(() => {
    document.title = 'Подтверждение личности';
    const checkUserStatus = async () => {
      try {
        const item = await PrivateData.getPrivateUser();
        if (item.passport.preapprove) {
          setIsPreApprove(true);
        }
        if (item.passport.approved === true) {
          dispatch(setVerified());
        }
      } catch (error) {
        console.error('Ошибка при получении данных пользователя:', error);
      } finally {
        setIsLoading(false);
      }
    };
    checkUserStatus();
  }, [dispatch, navigate]);

  if (isLoading) {
    return (
      <div className={proofIdentity('verified')}>
        <Loading />
      </div>
    );
  }

  if (!isPassport) {
    return (
      <div className={proofIdentity('verified')}>
        <div className={proofIdentity('verified-title')}>
          <h2>Необходимо заполнить паспортные данные</h2>
        </div>
        <div className={proofIdentity('')}>
          <p>
            Перед подтверждением личности необходимо
            <a href="/account#passport-data"> заполнить паспортные данные</a>.
          </p>
        </div>
      </div>
    );
  }

  if (passportError) {
    return (
      <div className={proofIdentity('verified')}>
        <div className={proofIdentity('verified-title')}>
          <div className={proofIdentity('icon-box')}>
            {!isPreApprove ? (
              <Icon externalClassName={proofIdentity('icon')} iconName="error" />
            ) : (
              <Icon externalClassName={proofIdentity('icon')} iconName="warning" />
            )}
          </div>
          <h2>{passportError}</h2>
        </div>
        <div className={proofIdentity('info')}>
          {isPreApprove ? (
            <p>
              Проверка занимает от нескольких секунд до получаса в зависимости от качества
              предоставленной фотографии паспорта. После успешной проверки аккаунт будет валидирован
              автоматически и значок кабинета станет зеленым.
            </p>
          ) : (
            <p>
              Автоматическая проверка паспорта закончилась неудачно. Вы можете подождать пока фото
              Вашего паспорта проверит менеджер вручную либо попробовать пройти{' '}
              <a href="/account#passport-data">процедуру верификации заново</a>, поправив данные
              и/или загрузив фото лучшего качества.
            </p>
          )}
        </div>
      </div>
    );
  }

  return !isPaswordVerified || !isApproved ? (
    <div className={proofIdentity()}>
      {/* <img src="photoPassport.jpg" alt="" /> */}
      <h2 className={proofIdentity('title')}>
        Предоставьте фото разворота паспорта как на примере ниже
      </h2>
      <div className={proofIdentity('photos-wrap')}>
        <div className={proofIdentity('photos')}>
          {!photoPassport ? (
            <div
              className={proofIdentity('photo', {
                disabled: isEnabled || photoPassport !== null,
              })}>
              {!isEnabled ? (
                <img
                  className={proofIdentity('photo-default')}
                  src={photo_default}
                  alt={photo_default}
                />
              ) : (
                <div className={proofIdentity('make-photo-box')}>
                  <video
                    className={proofIdentity('camera-photo')}
                    playsInline
                    muted
                    autoPlay
                    ref={videoRef}
                  />
                  <p className={proofIdentity('take-Photo')} onClick={() => makePhoto(videoRef)} />
                  <button
                    type="button"
                    className={proofIdentity('flip-camera')}
                    onClick={() => setFacing(facing === 'user' ? 'environment' : 'user')}>
                    Перевернуть
                  </button>
                  <button
                    className={proofIdentity('button-photo')}
                    type="button"
                    onClick={() => setEnabled(!isEnabled)}>
                    Закрыть
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className={proofIdentity('photo', { disabled: isEnabled })}>
              <img
                className={proofIdentity('received-photo')}
                src={URL.createObjectURL(photoPassport)}
                alt="Passport"
              />
              <button
                className={proofIdentity('button-photo')}
                type="button"
                onClick={() => deletePhoto(videoRef)}>
                Удалить
              </button>
            </div>
          )}
          <p className={proofIdentity('photos-description')}>Фото паспорта</p>
          <div className={proofIdentity('photos-buttons-wrap')}>
            <Button
              text="Загрузить фото"
              transparent
              externalClassName={proofIdentity('photos-buttons')}
              handleExternal={uploadPhoto}
            />
            <Button
              text="Сделать фото"
              transparent
              externalClassName={proofIdentity('photos-buttons')}
              handleExternal={() => setEnabled(!isEnabled)}
            />
          </div>
        </div>
      </div>
      <Checkbox
        text="Согласен(а)"
        linkText=" с политикой обработки персональных данных"
        linkUrl="/services#politics"
        externalClassName={proofIdentity('checkbox')}
        handleExternal={handleSetCheckBox}
      />
      <Button
        handleExternal={handleSavePassportDataPhoto}
        text="Подтвердить личность"
        disable={!disabledButton}
        externalClassName={proofIdentity('button')}
      />
      <div className={proofIdentity('text')}>
        <h4 className={proofIdentity('text-title')}>Зачем нужно подтверждение личности?</h4>
        <p className={proofIdentity('text-description')}>
          После подтверждения личность Вам будет доступно моментальное бронирование и{' '}
          <Link onClick={() => handleOpenModal()} to="#proof-of-identity">
            бесконтактное заселение.
          </Link>
          В случае других способов бронирования Вы сможете заключить договор непосредственно в
          квартире при встрече с агентом.
        </p>
        <Modal open={isOpen} handleClose={handleCloseModal}>
          <h3>Что такое бесконтактное заселение?</h3>
          <p className={proofIdentity('contactless-text')}>
            Квартиры с бесконтактным заселением оборудованы кодовым замком. После бронирования и
            оплаты в СМС или в нашем мобильном приложении Вы получите код доступа в квартиру,
            который будет действовать весь срок Вашего пребывания.
          </p>
          <p className={proofIdentity('contactless-text')}>
            Опция доступна для гостей,{' '}
            <Link to="#proof-of-identity">подтвердивших свою личность</Link> и{' '}
            <Link to="/">согласившихся с правилами проживания</Link>. Способы подтверждения и также
            правила проживания доступны зарегистрированным пользователям в личном кабинете
          </p>
          <Button
            externalClassName={proofIdentity('button-contactless')}
            text="Ок"
            handleExternal={handleCloseModal}
          />
        </Modal>
      </div>
      <div className={proofIdentity('text')}>
        <h4 className={proofIdentity('text-title')}>
          Сколько времени займет подтверждение личности?
        </h4>
        <p className={proofIdentity('text-description')}>
          Подтверждение личности происходит автоматически в течение минуты.
        </p>
      </div>
    </div>
  ) : (
    <div className={proofIdentity('verified')}>
      <div className={proofIdentity('verified-title')}>
        <div className={proofIdentity('icon-box')}>
          <Icon externalClassName={proofIdentity('icon')} iconName="checked" />
        </div>
        <h2>Личность подтверждена</h2>
      </div>
      <div className={proofIdentity('')}>
        <p>
          Ваша личность подтверждена, Вам доступно моментальное бронирование и бесконтактное
          заселение
        </p>
      </div>
    </div>
  );
};

export default ProofIdentity;
